/**
 * @generated SignedSource<<961fc87dbfd6f5f3bf0ff346698bd62e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverviewPreview_widget$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewContent_widget">;
  readonly " $fragmentType": "WidgetCalendarOverviewPreview_widget";
};
export type WidgetCalendarOverviewPreview_widget$key = {
  readonly " $data"?: WidgetCalendarOverviewPreview_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewPreview_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetCalendarOverviewPreview_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetCalendarOverviewContent_widget"
    }
  ],
  "type": "WidgetCalendarOverview",
  "abstractKey": null
};

(node as any).hash = "489409c9315260f73ac8249a60bd580f";

export default node;
